import styled from 'styled-components';
import { Checkbox as OriginalCheckbox } from './ChecklistItem.styles';
import ChevronIcon from '../components/icons/ChevronIcon';

export const StyledCheckbox = styled(OriginalCheckbox)`
  // You can add overrides here if needed, otherwise it will inherit all styles
  // from the original ChecklistItem checkbox.
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #B6C2CF;
  user-select: none;

  span {
    margin-left: 8px;
  }
`;

export const Checkbox = ({ checked, onChange, label }) => (
  <CheckboxLabel onClick={(e) => e.stopPropagation()}>
    <StyledCheckbox
      type="checkbox"
      checked={checked}
      onChange={onChange}
    />
    <span>{label}</span>
  </CheckboxLabel>
);


export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1300;
`;

export const ModalContent = styled.div`
  background: #282a2d; // Slightly lighter, more modern dark gray
  color: #e0e0e0;
  border-radius: 12px;
  width: 90%;
  max-width: 550px; // A bit wider for more content space
  max-height: 85vh; // A bit taller
  overflow: hidden; // We will handle scrolling inside
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2); // Softer shadow
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #888;
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  line-height: 1;

  &:hover {
    color: #fff;
  }
`;

export const ModalHeader = styled.div`
  padding: 24px;
  background: #2d2f32; // A slightly different shade for depth
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0; // Prevent header from shrinking
`;

export const ModalTitle = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  padding-bottom: 16px;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 16px; // Add gap between tabs
`;

export const TabButton = styled.button`
  padding: 10px 4px; // Adjust padding
  border: none;
  background: none;
  color: ${({ active }) => (active ? '#fff' : '#8899a6')};
  font-size: 16px;
  font-weight: ${({ active }) => (active ? '600' : '500')};
  cursor: pointer;
  position: relative;
  transition: color 0.2s ease;

  // Modern underline effect
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #fff;
    transform: ${({ active }) => (active ? 'scaleX(1)' : 'scaleX(0)')};
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:hover {
    color: #fff;
  }
`;

export const ImportContainer = styled.div`
  padding: 24px;
  color: #fff;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const Select = styled.select`
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;

  option {
    background: #282a2d;
    color: #fff;
  }
`;

export const FileInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const FileInputLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 32px;
  border-radius: 8px;
  border: 2px dashed #4f5257;
  background-color: #212326;
  color: #8899a6;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #007bff;
    color: #007bff;
  }
`;

export const FileInput = styled.input`
  display: none; // Hide the actual input
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column; // Stack them vertically
  gap: 12px;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  background-color: #212326;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:has(input:checked) {
    background-color: #2d2f32;
    box-shadow: 0 0 0 2px #007bff;
  }

  input {
    display: none; // Hide original radio button
  }
`;

export const MessageBox = styled.div`
  padding: 12px;
  border-radius: 8px;
  margin: 16px 0;
  font-size: 14px;
  background-color: ${props => {
    switch (props.type) {
      case 'info': return 'rgba(0, 123, 255, 0.1)';
      case 'success': return 'rgba(40, 167, 69, 0.1)';
      default: return '#212326';
    }
  }};
  border-left: 4px solid ${props => {
    switch (props.type) {
      case 'info': return '#007bff';
      case 'success': return '#28a745';
      default: return '#4f5257';
    }
  }};
  color: #e0e0e0;
`;

export const SavesList = styled.ul`
  list-style: none;
  padding: 8px 24px; // Add some vertical padding
  margin: 0;
  flex-grow: 1;
  overflow-y: auto; // Make this area scrollable
  background: #212326; // A slightly darker area for content

  /* Custom Scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #4f5257;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #676a70;
  }
`;

export const GroupHeader = styled.div`
  color: #e0e0e0;
  font-weight: 600;
  margin-top: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  user-select: none; // Prevent text selection on click

  &:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  .icon {
    margin-right: 12px; // More space for the icon
    transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1); // Smoother animation
    &.collapsed {
      transform: rotate(-90deg);
    }
  }
`;

export const SaveItem = styled.li`
  display: flex;
  align-items: center;
  padding: 10px 0 10px 42px; // Indent save items further
  color: #b0b8c4;
  font-size: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04); // Subtle separator

  &:last-child {
    border-bottom: none;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #2d2f32; // Match header
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0; // Prevent footer from shrinking
`;

export const GroupContainer = styled.div``;

export const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 8px; // Slightly more rounded
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:active {
    transform: scale(0.97);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.primary {
    background: linear-gradient(45deg, #007bff, #0056b3);
    color: white;
    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);
    &:hover {
      box-shadow: 0 6px 20px rgba(0, 123, 255, 0.3);
      transform: translateY(-1px);
    }
  }

  &.secondary {
    background-color: #3a3a3c;
    color: white;
    &:hover {
      background-color: #4a4a4c;
    }
  }
`;
